import EntityDeleteAction from '@/modules/entity/actions/EntityDeleteAction';
import EntityUnpublishAction from '@/modules/entity/actions/EntityUnpublishAction';
import EntityCloneAction from '@/modules/entity/actions/EntityCloneAction';
import EntityVersionNavigate from '@/modules/entity/actions/EntityVersionNavigateAction';
import EntityPreviewPaywall from '@/modules/entity/actions/EntityPreviewPaywallAction';
import EntityPreviewPaywallCondition from '@/modules/entity/actions/EntityPreviewPaywallConditionAction.vue';
import EntityPreviewPaywallMessage from '@/modules/entity/actions/EntityPreviewPaywallMessageAction.vue';
import EntityResetSecondFactorAction from '@/modules/entity/actions/EntityResetSecondFactorAction.vue';
import EntityInvalidateStaffCredentialsAction
  from '@/modules/entity/actions/EntityInvalidateStaffCredentialsAction.vue';

export const ACTION_DELETE = 'delete';
export const ACTION_UNPUBLISH = 'unpublish';
export const ACTION_CLONE = 'clone';
export const ACTION_VERSION_NAVIGATE = 'versionNavigate';
export const ACTION_PREVIEW_PAYWALL = 'previewPaywall';
export const ACTION_PREVIEW_PAYWALL_CONDITION = 'previewPaywallCondition';
export const ACTION_PREVIEW_PAYWALL_MESSAGE = 'previewPaywallMessage';
export const ACTION_RESET_SECOND_FACTOR = 'resetSecondFactor';
export const ACTION_INVALIDATE_STAFF_CREDENTIALS = 'invalidateStaffCredentials';

const actions = [
  {
    name: ACTION_DELETE,
    component: EntityDeleteAction,
    icon: 'delete',
  },
  {
    name: ACTION_UNPUBLISH,
    component: EntityUnpublishAction,
    icon: 'file_download',
  },
  {
    name: ACTION_CLONE,
    component: EntityCloneAction,
    icon: 'control_point_duplicate',
  },
  {
    name: ACTION_VERSION_NAVIGATE,
    component: EntityVersionNavigate,
    icon: 'history',
  },
  {
    name: ACTION_PREVIEW_PAYWALL,
    component: EntityPreviewPaywall,
    icon: 'euro',
  },
  {
    name: ACTION_PREVIEW_PAYWALL_CONDITION,
    component: EntityPreviewPaywallCondition,
    icon: 'euro',
  },
  {
    name: ACTION_PREVIEW_PAYWALL_MESSAGE,
    component: EntityPreviewPaywallMessage,
    icon: 'euro',
  },
  {
    name: ACTION_RESET_SECOND_FACTOR,
    component: EntityResetSecondFactorAction,
    icon: 'lock_outline',
  },
  {
    name: ACTION_INVALIDATE_STAFF_CREDENTIALS,
    component: EntityInvalidateStaffCredentialsAction,
    icon: 'no_encryption',
  },
];

/**
 * Register a new action, so it will be available in the entity editors.
 * @param {string} name
 * @param {Object} component
 * @param {string} icon
 */
export function registerEntityAction({ name, component, icon }) {
  actions.push({ name, component, icon });
}

export function getEntityActionsByNames(names) {
  return names
    .map(name => actions.find(action => action.name === name))
    .filter(action => !!action);
}
